import { CellContext } from '@tanstack/react-table'
import { WithdrawTransactionResponse } from '../../../../types'
import BankInfoCell from '../../../BankInfoCell'

type WithdrawData = WithdrawTransactionResponse['data'][number]

type PlayerBankInfoCellProps = {
	row: CellContext<WithdrawData, unknown>['row']
}

export default function PlayerBankInfoCell({ row }: PlayerBankInfoCellProps) {
	return <BankInfoCell bank={row.original.playerBank} />
}
